<section id="publicWifiDetails" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">
            {{ 'publicWifi.details.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <p [innerHTML]="'publicWifi.details.description' | translate: true"></p>
            <p [innerHTML]="'publicWifi.details.learnMore.link' | translate: true"></p>

            <div class="row">
              <div class="columns small-12 medium-4 end">
                <mprd-public-wifi-selector></mprd-public-wifi-selector>
              </div>
            </div>

            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 large-9 end">
                <mprd-public-wifi-accounts></mprd-public-wifi-accounts>
              </div>
            </div>

            <div class="rs-me"></div>

            <h2>{{ 'publicWifi.details.faqTitle' | translate }}</h2>

            <p [innerHTML]="'publicWifi.details.faqContent' | translate: true"></p>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
